export function unwrapLeadNotificationApiData(response, fallback) {
  if (response && response.data && Object.prototype.hasOwnProperty.call(response.data, 'data')) {
    return response.data.data;
  }
  return fallback;
}
